import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BalancePage } from '@pages/balance/balance.page';
import { InfoPage } from '@pages/info/info.page';
import { LoginPage } from '@pages/login/login.page';
import { ProtocolPage } from '@pages/protocol/protocol.page';
import { SubscribersPage } from '@pages/subscribers/subscribers.page';
import { CustomHttpInterceptor } from '@services/custom-http.interceptor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomePage } from '@pages/home/home.page';
import { NgWhiteboardModule } from 'ng-whiteboard';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { LOAD_WASM, NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';
import { AccordionModule } from 'primeng/accordion';
import { AnimateModule } from 'primeng/animate';
import * as PrimeNG from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DockModule } from 'primeng/dock';
import { DragDropModule } from 'primeng/dragdrop';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { ImageModule } from 'primeng/image';
import { InplaceModule } from 'primeng/inplace';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { KnobModule } from 'primeng/knob';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { ScrollerModule } from 'primeng/scroller';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SliderModule } from 'primeng/slider';
import { SpeedDialModule } from 'primeng/speeddial';
import { SpinnerModule } from 'primeng/spinner';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeSelectModule } from 'primeng/treeselect';
import { TreeTableModule } from 'primeng/treetable';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { AccessHistoryDialogComponent } from './components/access-history-dialog/access-history-dialog.component';
import { AgreedUserComponent } from './components/agreed-user/agreed-user.component';
import { AuthorizedUsersDialogComponent } from './components/authorized-users-dialog/authorized-users-dialog.component';
import { ChangePasswordDialogComponent } from './components/change-password-dialog/change-password-dialog.component';
import { LoadingDialogComponent } from './components/loading-dialog/loading-dialog.component';
//import { ProblemReportComponent } from './components/problem-report/problem-report.component';
import { RegulationDialogComponent } from './components/regulation-dialog/regulation-dialog.component';
import { AgreementViewComponent } from './pages/agreement-view/agreement-view.component';
import { AgreementComponent } from './pages/agreement/agreement.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { SequenceCreatorDialogComponent } from './pages/contacts/sequence-creator-dialog/sequence-creator-dialog.component';
import { SequenceValidatorDialogComponent } from './pages/contacts/sequence-validator-dialog/sequence-validator-dialog.component';
import { DelegatesComponent } from './pages/delegates/delegates.component';
import { FunctionalityListDialogComponent } from './pages/groups/functionality-list-dialog/functionality-list-dialog.component';
import { GroupsComponent } from './pages/groups/groups.component';
import { OrganizationChartViewComponent } from './pages/organization-chart-view/organization-chart-view.component';
import { PermissionManagementComponent } from './pages/permission-management/permission-management.component';
import { PermissionDialogComponent } from './pages/permission-management/permission/permission.component';
import { RevokePermissionComponent } from './pages/permission-management/revoke-permission/revoke-permission.component';
import { DocumentCreationDialogComponent } from './pages/protocol/document-creation-dialog/document-creation-dialog.component';
import { QuestionComponent } from './pages/question/question.component';
import { RegulationManagerComponent } from './pages/regulation-manager/regulation-manager.component';
import { DelegationConfirmComponent } from './pages/subscribers/delegation-confirm/delegation-confirm.component';
import { DelegationDialogComponent } from './pages/subscribers/delegation-dialog/delegation-dialog.component';
import { UserAccessComponent } from './pages/user-access/user-access.component';
import { UserInfoComponent } from './pages/user-info/user-info.component';
import { VoteComponent } from './pages/vote/vote.component';
import { SortPipe } from './pipe/sort.pipe';

import {
  LocationStrategy,
  PathLocationStrategy,
  registerLocaleData,
} from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { NominationDialogComponent } from '@components/nomination-dialog/nomination-dialog.component';
import { ShippingManagementComponent } from '@pages/shipping-management/shipping-management.component';
import { AvailabilityDialogComponent } from './components/availability-dialog/availability-dialog.component';
import { DocumentReaderDialogComponent } from './components/document-reader-dialog/document-reader-dialog.component';
import { NominationComponent } from './pages/nomination/nomination.component';
import { InfoPageComponent } from './pages/info-page/info-page.component';
import { ViewNominationComponent } from './pages/view-nomination/view-nomination.component';
import { ProblemReportPageComponent } from './pages/problem-report-page/problem-report-page.component';

registerLocaleData(localeIt);

LOAD_WASM().subscribe();

@NgModule({
  declarations: [
    AppComponent,
    SubscribersPage,
    ProtocolPage,
    BalancePage,
    LoginPage,
    InfoPage,
    GroupsComponent,
    HomePage,
    DelegationDialogComponent,
    DelegatesComponent,
    AgreementComponent,
    OrganizationChartViewComponent,
    FunctionalityListDialogComponent,
    QuestionComponent,
    AuthorizedUsersDialogComponent,
    VoteComponent,
    DocumentCreationDialogComponent,
    ContactsComponent,
    PermissionDialogComponent,
    UserInfoComponent,
    ChangePasswordDialogComponent,
    SortPipe,
    DelegationConfirmComponent,
    RevokePermissionComponent,
    PermissionManagementComponent,
    LoadingDialogComponent,
    AgreementViewComponent,
    UserAccessComponent,
    AccessHistoryDialogComponent,
    RegulationManagerComponent,
    RegulationDialogComponent,
    AgreedUserComponent,
    ShippingManagementComponent,
    //ProblemReportComponent,
    SequenceCreatorDialogComponent,
    SequenceValidatorDialogComponent,
    AvailabilityDialogComponent,
    NominationDialogComponent,
    DocumentReaderDialogComponent,
    NominationComponent,
    InfoPageComponent,
    ViewNominationComponent,
    ProblemReportPageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AvatarModule,
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    NgWhiteboardModule,
    ReactiveFormsModule,
    AccordionModule,
    AutoCompleteModule,
    BadgeModule,
    BreadcrumbModule,
    BlockUIModule,
    ButtonModule,
    CalendarModule,
    CarouselModule,
    CascadeSelectModule,
    ChartModule,
    CheckboxModule,
    ChipsModule,
    ChipModule,
    ColorPickerModule,
    ConfirmDialogModule,
    ContextMenuModule,
    VirtualScrollerModule,
    DataViewModule,
    DialogModule,
    DividerModule,
    DockModule,
    DragDropModule,
    DropdownModule,
    DynamicDialogModule,
    EditorModule,
    FieldsetModule,
    FileUploadModule,
    GalleriaModule,
    InplaceModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    InputNumberModule,
    ImageModule,
    KnobModule,
    ListboxModule,
    MegaMenuModule,
    MenuModule,
    MenubarModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    NgxScannerQrcodeModule,
    NgxExtendedPdfViewerModule,
    OrganizationChartModule,
    OrderListModule,
    OverlayPanelModule,
    PaginatorModule,
    PanelModule,
    NgxBarcode6Module,
    PanelMenuModule,
    PasswordModule,
    PickListModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    RadioButtonModule,
    RatingModule,
    SelectButtonModule,
    SidebarModule,
    ScrollerModule,
    ScrollPanelModule,
    ScrollTopModule,
    SkeletonModule,
    SlideMenuModule,
    SliderModule,
    SpeedDialModule,
    SpinnerModule,
    SplitterModule,
    SplitButtonModule,
    StepsModule,
    TableModule,
    TabMenuModule,
    TabViewModule,
    TagModule,
    TerminalModule,
    TieredMenuModule,
    TimelineModule,
    ToastModule,
    ToggleButtonModule,
    ToolbarModule,
    TooltipModule,
    TriStateCheckboxModule,
    TreeModule,
    TreeSelectModule,
    TreeTableModule,
    AnimateModule,
    CardModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'it-IT' },
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    Location,
    {
      provide: PrimeNG.PrimeNGConfig,
      useFactory: () => {
        let config = new PrimeNG.PrimeNGConfig();
        config.translation = {
          dayNames: [
            'Domenica',
            'Lunedì',
            'Martedì',
            'Mercoledì',
            'Giovedì',
            'Venerdì',
            'Sabato',
          ],
          dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
          dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
          monthNames: [
            'Gennaio',
            'Febbraio',
            'Marzo',
            'Aprile',
            'Maggio',
            'Giugno',
            'Luglio',
            'Agosto',
            'Settembre',
            'Ottobre',
            'Novembre',
            'Dicembre',
          ],
          monthNamesShort: [
            'Gen',
            'Feb',
            'Mar',
            'Apr',
            'Mag',
            'Giu',
            'Lug',
            'Ago',
            'Set',
            'Ott',
            'Nov',
            'Dic',
          ],
          firstDayOfWeek: 1,
          today: 'Oggi',
        };
        return config;
      },
    },
    DialogService,
    PrimeNG.MessageService,
    PrimeNG.ConfirmationService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
